import { styled, DialogContent, DialogTitle } from "@mui/material";
import { colors } from "../../../utils";

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  display: "flex",
  gap: "24px",
  flexDirection: "column",
  paddingLeft: "16px",
  paddingRight: "16px",
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "16px 0px 0px 0px"
}));

export const HeaderIcon = styled("img")(({ theme }) => ({
  width: "40px",
  height: "40px",
}));

export const StyledTermsContent = styled("div")(({ theme }) => ({
  height: "90%",
  overflow: "auto",
  borderBottom: "1px solid #E1E1E1",
  paddingBottom: "16px",
}));

export const TermsButton = styled("div")(() => ({
    color: "blue",
    textDecoration: "underline",
    cursor: "pointer",
    "&:hover": {
        color: colors.primary
    }
}));